import { AbortDictionary, getApiCall, getFileApiCall, postApiCall, postFileApiCall } from "./tokenService";
import { AppReportPage } from "../appReport/appReportPage";
import { AppReportPageData } from "../appReport/appReportPageData";
import { UnitNodePermissions } from "../unit/unitNodePermissions";
import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { ModuleUnits } from "../unit/moduleUnits";
import { UnitModuleSaveResult } from "../unit/unitModuleSaveResult";
import { AppReportTemplateListItems } from "ui/Scripts/source/models/appReportTemplate/appReportTemplateListItems";
import { AppReportTemplateNew } from "ui/Scripts/source/models/appReportTemplate/appReportTemplateNew";
import { AppReportTemplateEdit } from "ui/Scripts/source/models/appReportTemplate/appReportTemplateEdit";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { TaskTypePrintHtml } from "../taskType/taskTypePrintHtml";
import { AppReportListItems } from "ui/Scripts/source/models/appReport/appReportListItems";
import { AppReportEdit } from "ui/Scripts/source/models/appReport/appReportEdit";
import { AppReportNew } from "ui/Scripts/source/models/appReport/appReportNew";
import { AppReportNewUnitChange } from "ui/Scripts/source/models/appReport/appReportNewUnitChange";
import { AppReportNewAppReportTemplateChange } from "ui/Scripts/source/models/appReport/appReportNewAppReportTemplateChange";
import { AppReportEditUnitChange } from "ui/Scripts/source/models/appReport/appReportEditUnitChange";
import { DocumentFolders } from "../document/documentFolders";
import { AppReportEventReferenceData } from "ui/Scripts/source/models/appReportTemplate/appReportEventReferenceData";
import { AppReportTaskReferenceData } from "ui/Scripts/source/models/appReportTemplate/appReportTaskReferenceData";
import { AppReportRecordReferenceData } from "ui/Scripts/source/models/appReportTemplate/appReportRecordReferenceData";

//Abort
//const commonAborts = new AbortDictionary();
const reportAborts = new AbortDictionary();
const chartAborts = new AbortDictionary();
const statisticAborts = new AbortDictionary();

// #region AppReportPage
export const getAppReportPage = (): Promise<AppReportPage> => {
    return getApiCall("api/appreport", AppReportPage);
};

export const getAppReportPageData = (companyId: string): Promise<AppReportPageData> => {
    return getApiCall("api/appreport/pagedata?id=" + companyId, AppReportPageData);
};
// #endregion AppReportPage

// #region List
export const sendAppReportReadReceipt = (companyId: string, id: string): Promise<ApiSuccess> => {
    return postApiCall("api/appreport/sendreadreceipt", ApiSuccess, JSON.stringify({
        companyId,
        id
    }));
};

export const getAppReportListItems = (companyId: string, pageSize: number, page: number, thrashBin: boolean, filter: string, startDate: number, endDate: number, unitIds: string[],
    stateIds: string[], sortColumn: string, sortOrderIsAsc: boolean): Promise<AppReportListItems> => {
    reportAborts.abortAll();
    chartAborts.abortAll();
    statisticAborts.abortAll();
    return postApiCall("api/appreport/list", AppReportListItems, JSON.stringify({
        companyId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        thrashBin,
        filter: filter || "",
        startDate,
        endDate,
        stateIds,
        unitIds
    }));
};
// #endregion List

// #region New
export const getAppReportNew = (companyId: string): Promise<AppReportNew> => {
    return getApiCall("api/appreport/new?id=" + companyId, AppReportNew);
};

export const getAppReportNewUnitChange = (companyId: string, unitId: string): Promise<AppReportNewUnitChange> => {
    return getApiCall("api/appreport/new/unitchange?id=" + unitId + "&companyId=" + companyId, AppReportNewUnitChange);
};

export const getAppReportNewAppReportTemplateChange = (companyId: string, appReportTemplateId: string): Promise<AppReportNewAppReportTemplateChange> => {
    return getApiCall("api/appreport/new/reporttemplatechange?id=" + appReportTemplateId + "&companyId=" + companyId, AppReportNewAppReportTemplateChange);
};
// #endregion New

// #region Edit
export const getAppReportEdit = (companyId: string, taskId: string, lockAppReport: boolean): Promise<AppReportEdit> => {
    return getApiCall("api/appreport/edit?id=" + taskId + "&companyId=" + companyId + "&lockAppReport=" + lockAppReport, AppReportEdit);
};

export const getAppReportEditUnitChange = (companyId: string, unitId: string): Promise<AppReportEditUnitChange> => {
    return getApiCall("api/appreport/edit/unitchange?id=" + unitId + "&companyId=" + companyId, AppReportEditUnitChange);
};

export const getAppReportEditDocumentFoldersAndDocuments = (companyId: string, unitId: string): Promise<DocumentFolders> => {
    return getApiCall("api/appreport/edit/foldersanddocuments?id=" + companyId + "&unitId=" + unitId, DocumentFolders);
};

export const getAppReportEventReferenceData = (companyId: string, unitId: string): Promise<AppReportEventReferenceData> => {
    return getApiCall("api/appreport/edit/eventreferencedata?id=" + companyId + "&unitId=" + unitId, AppReportEventReferenceData);
};

export const getAppReportTaskReferenceData = (companyId: string, unitId: string): Promise<AppReportTaskReferenceData> => {
    return getApiCall("api/appreport/edit/taskreferencedata?id=" + companyId + "&unitId=" + unitId, AppReportTaskReferenceData);
};

export const getAppReportRecordReferenceData = (companyId: string, unitId: string): Promise<AppReportRecordReferenceData> => {
    return getApiCall("api/appreport/edit/recordreferencedata?id=" + companyId + "&unitId=" + unitId, AppReportRecordReferenceData);
};

export const saveAppReportEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/appreport/save", SaveSuccess, JSON.stringify(obj));
};

export const removeAppReport = (companyId: string, appReportId: string): Promise<ApiSuccess> => {
    return postApiCall("api/appreport/remove?id=" + appReportId + "&companyId=" + companyId, ApiSuccess);
};
// #endregion Edit

// #region Print
export const getAppReportDraftPrint = (companyId: string, appReportId: string): Promise<string> => {
    return getFileApiCall("api/appreport/printdraft?id=" + appReportId + "&companyId=" + companyId);
};

export const getAppReportPublishedPrint = (companyId: string, appReportId: string): Promise<string> => {
    return getFileApiCall("api/appreport/printpublished?id=" + appReportId + "&companyId=" + companyId);
};
// #endregion Print

// #region Publishing
export const publishAppReport = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/appreport/publish", SaveSuccess, JSON.stringify(obj));
};

export const unpublishAppReport = (companyId: string, appReportId: string, rowId: string): Promise<SaveSuccess> => {
    return postApiCall("api/appreport/unpublish", SaveSuccess, JSON.stringify({
        companyId,
        id: appReportId,
        rowId
    }));
};
// #endregion Publishing

// #region Archiving
export const archiveAppReport = (companyId: string, appReportId: string, rowId: string): Promise<SaveSuccess> => {
    return postApiCall("api/appreport/archive", SaveSuccess, JSON.stringify({
        companyId,
        id: appReportId,
        rowId
    }));
};

export const restoreAppReportFromArchive = (companyId: string, appReportId: string, rowId: string): Promise<SaveSuccess> => {
    return postApiCall("api/appreport/restorefromarchive", SaveSuccess, JSON.stringify({
        companyId,
        id: appReportId,
        rowId
    }));
};

export const emptyTrashBin = (companyId: string): Promise<ApiSuccess> => {
    return postApiCall("api/appreport/emptytrash?id=" + companyId, ApiSuccess);
};
// #endregion Archiving

// #region Trash Bin
export const moveAppReportToTrashBin = (companyId: string, appReportId: string, rowId: string): Promise<SaveSuccess> => {
    return postApiCall("api/appreport/movetotrash", SaveSuccess, JSON.stringify({
        companyId,
        id: appReportId,
        rowId
    }));
};

export const restoreAppReportFromTrashBin = (companyId: string, appReportId: string, rowId: string): Promise<SaveSuccess> => {
    return postApiCall("api/appreport/restorefromtrash", SaveSuccess, JSON.stringify({
        companyId,
        id: appReportId,
        rowId
    }));
};
// #endregion Trash Bin

// #region Module Permissions
export const getUnitNodePermissions = (companyId: string): Promise<UnitNodePermissions> => {
    return getApiCall("api/appreport/module/permissions?id=" + companyId, UnitNodePermissions);
};

export const saveUnitNodePermissions = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/appreport/module/savepermissions", ApiSuccess, JSON.stringify(obj));
};
// #endregion Module Permissions

// #region Module units
export const getUnits = (companyId: string): Promise<ModuleUnits> => {
    return getApiCall("api/appreport/module/units?id=" + companyId, ModuleUnits);
};

export const saveUnits = (obj: any): Promise<UnitModuleSaveResult> => {
    return postApiCall("api/appreport/module/saveunits", UnitModuleSaveResult, JSON.stringify(obj));
};
// #endregion Module units

// #region Module report templates
export const getAppReportTemplateListItems = (companyId: string, pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean, ignoreReportTemplatesOfCompanyId: string): Promise<AppReportTemplateListItems> => {
    return postApiCall("api/appreport/module/reporttemplate/list", AppReportTemplateListItems, JSON.stringify({
        companyId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || "",
        ignoreReportTemplatesOfCompanyId
    }));
};

export const getAppReportTemplateNew = (companyId: string): Promise<AppReportTemplateNew> => {
    return getApiCall("api/appreport/module/reporttemplate/new?id=" + companyId, AppReportTemplateNew);
};

export const getAppReportTemplateEdit = (companyId: string, id: string, addToCompany: boolean): Promise<AppReportTemplateEdit> => {
    return getApiCall("api/appreport/module/reporttemplate/edit?id=" + id + "&companyId=" + companyId + "&addToCompany=" + addToCompany, AppReportTemplateEdit);
};

export const getAppReportTemplateEditDocumentFoldersAndDocuments = (companyId: string): Promise<DocumentFolders> => {
    return getApiCall("api/appreport/module/reporttemplate/edit/foldersanddocuments?id=" + companyId, DocumentFolders);
};

export const saveAppReportTemplateEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/appreport/module/reporttemplate/save", SaveSuccess, JSON.stringify(obj));
};

export const removeAppReportTemplates = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/appreport/module/reporttemplate/remove", ApiSuccess, JSON.stringify(obj));
};

export const getAppReportTemplatePreviewPrintHtml = (obj: any): Promise<TaskTypePrintHtml> => {
    return postApiCall("api/appreport/module/reporttemplate/previewprinthtml", TaskTypePrintHtml, JSON.stringify(obj));
};

export const getAppReportTemplatePreviewPrint = (obj: any): Promise<string> => {
    return postFileApiCall("api/appreport/module/reporttemplate/previewprint", JSON.stringify(obj));
};
// #endregion Module task types

// #region Module task type units
export const appReportTemplateAddUnits = (companyId: string, reportTemplateId: string, unitIds: string[]): Promise<ApiSuccess> => {
    return postApiCall("api/appreport/module/reporttemplate/addunits", ApiSuccess, JSON.stringify({
        companyId,
        reportTemplateId,
        unitIds
    }));
};

export const appReportTemplateRemoveUnits = (companyId: string, reportTemplateId: string, unitIds: string[]): Promise<ApiSuccess> => {
    return postApiCall("api/appreport/module/reporttemplate/removeunits", ApiSuccess, JSON.stringify({
        companyId,
        reportTemplateId,
        unitIds
    }));
};
// #endregion Module task type units
